
import Text from "@/components/common/Typography/Text"
import { useAppSelector } from "@/lib/redux/hooks"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Col, Collapse, Divider, Empty, List, Popover, Row, Tag } from "antd"
import { FC, useContext, useState } from "react"
import PlacementsByCountry from "./PlacementsByCountry"
import { SelectPlacementContext } from "."
import MarkIcon from "@/components/icons/MarkIcon"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"

type ResultAirportsProps = {
}
const ResultAirports: FC<ResultAirportsProps> = () => {
  const countryCodes = useAppSelector(state => state.flight.countryCodes)
  const countryData = useAppSelector(state => state.flight.countryData)
  const searchPopular = useAppSelector(state => state.flight.searchPopular)
  const isDesktop = useIsDesktop()
  const [openKeys, setOpenKeys] = useState<any[]>([])
  const { onChange, searching } = useContext(SelectPlacementContext)
  const mappingCountriesAirports = useAppSelector(state => state.flight.mappingCountriesAirports)

  if (!countryCodes.length) {
    return <Empty />
  }

  if (searching && !searchPopular) {
    return <></>
  }

  if (!isDesktop) {
    return (
      <Collapse
        activeKey={openKeys}
        onChange={(keys) => setOpenKeys(keys)}
        size='small'
        expandIconPlacement='end'
        bordered={false}
        style={{
          background: 'none'
        }}
        destroyOnHidden
        items={countryCodes
          .filter(countryCode => countryData[countryCode]?.isDomestic === "0" || !!searching)
          .map((countryCode) => {
            return {
              label: (
                <Text style={{ margin: 0 }}>
                  <MarkIcon /> {`${countryData[countryCode]?.name || ""} (${countryData[countryCode]?.count || 0})`}
                </Text>
              ),
              key: countryCode,
              styles: {
                body: {
                  paddingInline: '1rem'
                },
                header: {
                  paddingInline: '1.2rem'
                }
              },
              style: { border: 'none' },
              children: (
                <PlacementsByCountry
                  onChange={onChange}
                  key={countryCode}
                  countryCode={countryCode}
                />
              )
            }
          })}
      />
    )
  }

  return (
    <>
      {!searching && <Divider style={{ marginBlock: '1.2rem' }} />}
      <List
        style={{ paddingInline: '1.2rem' }}
        dataSource={countryCodes
          .filter(countryCode => countryData[countryCode]?.isDomestic === "0" || !!searching)
          .map(countryCode => ({ ...countryData[countryCode], code: countryCode }))}

        renderItem={({ name, count, code }) => {
          const airportCodes = mappingCountriesAirports[code]
          return (
            <List.Item style={{ border: 'none', cursor: 'pointer', userSelect: 'none' }}>
              <Popover
                placement='rightTop'
                content={(
                  <PlacementsByCountry
                    onChange={onChange}
                    key={code}
                    countryCode={code}
                  />
                )}
                styles={{
                  content: {
                    maxHeight: "30rem",
                    overflow: "auto"
                  }
                }}
              >
                <Row style={{ width: '100%' }} align='middle' justify='space-between'>
                  <Col>
                    <Text style={{ margin: 0 }}>
                      <MarkIcon /> {`${name || ""} (${airportCodes.length || 0})`}
                    </Text>
                  </Col>
                  <Col>
                    <FontAwesomeIcon icon={faChevronRight} />
                  </Col>
                </Row>
              </Popover>
            </List.Item>
          )
        }}
      />
    </>
  )
}

export default ResultAirports